export const RegisterTypeConst = {
  TEL_NO: "telno",
  EMAIL: "email",
};
